"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearBasketPopUp = void 0;
var ClearBasketEvent = _interopRequireWildcard(require("@ori-events/clear-basket"));
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const ClearBasketPopUp = ({
  visible,
  setVisible
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    setShouldMutateCombineSection
  } = (0, _contexts.useBasketContext)();
  const onClose = (0, _react.useCallback)(() => setVisible(false), [setVisible]);
  const onConfirm = (0, _react.useCallback)(() => {
    const clearBasketEvent = new CustomEvent(ClearBasketEvent.Name);
    window.dispatchEvent(clearBasketEvent);
    setShouldMutateCombineSection(true);
    onClose();
  }, [onClose, setShouldMutateCombineSection]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
    hideCloseButton: true,
    open: visible,
    "data-testid": getTestId('clear-basket-popup'),
    header: formatMessage('doYouWantToClearYourBasket'),
    actions: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      color: "error",
      variant: "contained",
      id: "accept",
      "data-testid": getTestId('clear-basket-popup-confirm'),
      onClick: onConfirm,
      children: formatMessage('yes')
    }, "accept"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      component: "button",
      id: "no",
      "data-testid": getTestId('clear-basket-popup-cancel'),
      onClick: onClose,
      children: formatMessage('no')
    }, "no")],
    severity: "info",
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      "data-testid": getTestId('clear-basket-popup-message'),
      children: formatMessage('itemsAddedByOriflameWillBeKept')
    })
  });
};
exports.ClearBasketPopUp = ClearBasketPopUp;